import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BASE_ROUTE;


const requestPasswordReset = async (email, ip) => {
    var query = "";

    if(ip){
        query += `?ipAddress=${ip}`
    }

    const response = await axios.post(`${BASE_URL}client/forgot-password` + query, { email });
    return response.data;
};

const resetPassword = async (code, newPassword, ip) => {
    var query = "";

    if(ip){
        query += `?ipAddress=${ip}`
    }
    const response = await axios.post(`${BASE_URL}client/reset-password` + query, { code, newPassword });
    return response.data;
};

export const passwordService = {
    requestPasswordReset,
    resetPassword,
};